import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a41e46a&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a41e46a')) {
      api.createRecord('1a41e46a', component.options)
    } else {
      api.reload('1a41e46a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1a41e46a&", function () {
      api.rerender('1a41e46a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboards/index.vue"
export default component.exports